import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { store } from '../src/store/index';
import { Provider } from 'react-redux';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from './authConfig';
import { BrowserRouter } from "react-router-dom";
import { AiOutlineStop } from "react-icons/ai";
import { removeSecureData } from './utils/secureStorage';

export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    
      msalInstance.setActiveAccount(event.payload.account);
  }

  else if (event.eventType === EventType.LOGIN_FAILURE || event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    toast.error("Erro de autenticação: Verifique as suas credenciais de login.", {
      icon: <AiOutlineStop/>
    });
    msalInstance.logoutRedirect();
    removeSecureData('isSessionId');
    removeSecureData('isCookieId');
    removeSecureData('isHasAccess');
    removeSecureData('isAccessToken');
    removeSecureData('isAssociatedInsuraceList');
    removeSecureData('isNAssocia');
    removeSecureData('isRedirectUrl');
    removeSecureData('isTokenExpiresOn');
  }

  else if (event.eventType === EventType.LOGIN_SUCCESS && !event.payload.account) {
      msalInstance.loginRedirect().then((response) => {
      const account = response.account;
      msalInstance.setActiveAccount(account);
  
    }).catch((error) => {
      toast.error("Erro de autenticação. Por favor, tente mais tarde.", {
        icon: <AiOutlineStop/>
      });
    });
  }
});


const root = ReactDOMClient.createRoot(document.getElementById('root'));


root.render(
  //<React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <ToastContainer
          position="bottom-center"
          autoClose={false}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <BrowserRouter basename='/carteira-virtual'>
          <App />
        </BrowserRouter>
      </Provider>
    </MsalProvider>
  //</React.StrictMode>
);

reportWebVitals();
